import React, { useState, useEffect } from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const NoctrifyPromo = ({ triggerShow = false }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already seen this popup
    const hasSeenPromo = localStorage.getItem('noctrifyPromoSeen');
    
    // Show popup when triggered (after meeting booking) and user hasn't seen it before
    // Note: localStorage returns strings, so check for 'true' string specifically
    if (triggerShow && hasSeenPromo !== 'true' && !isVisible) {
      setIsVisible(true);
    }
  }, [triggerShow, isVisible]);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('noctrifyPromoSeen', 'true');
  };

  const handleVisitNoctrify = () => {
    window.open('https://noctrify.com/', '_blank');
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <div className="noctrify-promo-overlay">
      <div className="noctrify-promo-modal">
        <div className="promo-close" onClick={handleClose}>
          <i className="fas fa-times"></i>
        </div>
        
        <div className="promo-content">
          <div className="promo-icon">
            <i className="fas fa-globe"></i>
          </div>
          
          <h3 className="promo-title">
            {t('promo-title')}
          </h3>
          
          <p className="promo-description">
            {t('promo-description')}
          </p>
          
          <div className="promo-features">
            <div className="promo-feature">
              <i className="fas fa-check"></i>
              <span>{t('promo-feature-1')}</span>
            </div>
            <div className="promo-feature">
              <i className="fas fa-check"></i>
              <span>{t('promo-feature-2')}</span>
            </div>
            <div className="promo-feature">
              <i className="fas fa-check"></i>
              <span>{t('promo-feature-3')}</span>
            </div>
          </div>
          
          <div className="promo-actions">
            <button className="btn btn-primary" onClick={handleVisitNoctrify}>
              {t('promo-visit-noctrify')} <i className="fas fa-external-link-alt"></i>
            </button>
            <button className="btn btn-secondary" onClick={handleClose}>
              {t('promo-maybe-later')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoctrifyPromo;